import { Container } from "../SDS/Container";
import { Grid, type GridFlow } from "@sede-enterprise/shell-ds-react-framework";
import { Outlet } from "react-router-dom";
import NavBar from "../NavBar";

const Layout = () => {
  const gridProps = {
    columns: 1,
    flow: "row" as GridFlow,
    style: {
      padding: "4px",
      borderRadius: "4px",
    },
  };

  const cellNavBarProps = {
    style: {
      minHeight: "60px",
      padding: "4px",
      borderRadius: "4px",
    },
  };

  const mainContentCellProps = {
    style: {
      height: "calc(100vh - 80px)", // Fixed height for main content area (accounting for navbar)
      padding: "1rem",
      borderRadius: "4px",
      overflow: "auto", // Allow scrolling at this level if content overflows
      display: "flex",
      flexDirection: "column" as const,
    },
  };

  return (
    <Container>
      {/* NavBar */}
      <Grid {...gridProps}>
        <Grid.Cell {...cellNavBarProps}>
          <NavBar />
        </Grid.Cell>
      </Grid>

      {/* Main Content - This will be replaced by child routes */}
      <Grid {...gridProps}>
        <Grid.Cell {...mainContentCellProps}>
          <Outlet />
        </Grid.Cell>
      </Grid>
    </Container>
  );
};

export default Layout;
